module.exports = __webpack_public_path__ + "img/IT코딩교육플렛폼.682d5c71.png";